<template>
	<footer :id="'foo'" class="main-footer content__custom">
		<p>{{ 'any-questions' | translate | capitalize }} {{ 'contact-us' | translate | capitalize }}
			<a href="mailto:contato@appcivico.com?subject=Dúvidas">contato@appcivico.com</a>
		</p>
		<p>
			{{ 'all-rights-reserved' | translate | capitalize }} {{ new Date().getFullYear() }}
			<a href="http://appcivico.com" target="_blank"> AppCívico.</a>
		</p>
	</footer>
</template>
<script>
	export default {
		name: 'mfooter',
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/m-footer.vue